<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<template>
  <div id="manage">
    <div class="content">
        <div class="title">证书管理</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input 
                        id="demo" 
                        v-model="keyword" 
                        icon="ios-search" 
                        placeholder="姓名/证件号/证书编号" 
                        style="width: 220px;height:34px;border:1px solid #e7e7eb;margin:20px 0;" 
                        class="bradius" 
                        @on-click="search(1)" 
                        @keyup.enter.native="search(1)" 
                        autocomplete="off"></Input>
                        <Select v-model="levalId" placeholder="请选择级别" class="borDiv" style="width:200px;border:1px solid #e7e7eb;margin:20px 10px;" @on-change="search(1)">
                            <Option v-for="item in levelList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                    <div class="fl_right addClass" @click="upload">下载模板</div>
                    <div class="fl_right addClass" @click="daoru" style="margin:22px 20px 0;">导入EXCEL</div>
                    <div class="fl_right addClass" @click="addRecruit">新增证书</div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
            <div class="alertBox" v-if="alertShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">{{valm==1?'编辑':'添加'}}</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">姓名</div>
                            <div class="fl_left inputBox">
                                <Input v-model="name" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入证书姓名" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">性别</div>
                            <div class="fl_left inputBox">
                                <RadioGroup v-model="teatsex">
                                    <Radio label="男">男</Radio>
                                    <Radio label="女">女</Radio>
                                </RadioGroup>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">学历</div>
                            <div class="fl_left inputBox">
                                <Input v-model="xueli" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入学历" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">证件号</div>
                            <div class="fl_left inputBox">
                                <Input v-model="cardCode" @input="cardCode=cardCode.replace(/[^\w\/]/ig,'').toUpperCase()" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入证件号" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">级别</div>
                            <div class="fl_left inputBox">
                                <Select v-model="level_id" class="bordiv" placeholder="请选择级别" filterable style="width:167px;margin-right:10px;height:36px;">
                                 <Option v-for="item in levelArr" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">证书编号</div>
                            <div class="fl_left inputBox">
                                <Input v-model="cardNum" class="bordiv" size="large" style="width:440px;" placeholder="请输入证书编号" />
                                <input type="text" autocomplete="off" name="" style="display:none">
                                <!-- <div>登录账号初始密码为<span style="color:#c30d23;">000000</span></div> -->
                            </div>
                            <div class="clear"></div>
                        </div>
                        
                    </div>
                    <div class="tanBtn" @click="tanyes(valm)">确定</div>
                </div>
            </div>
            <div class="alertBox" v-if="alertShowUp" style="padding-top:6%;">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">上传</div>
                        <div class="fl_right tandel" @click="tandelUp"></div>
                        <div class="clear"></div>
                    </div>
                    <div style="color:#c30d23;text-align: center;">上传成功后，解析需要1-2分钟的时间来完成，稍后刷新页面即可！</div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">上传EXCEL</div>
                            <div class="fl_left file-list" style="width: 465px;">
                                <el-upload
                                  class="upload-demo"
                                  accept=".xlsx"
                                  :action="unpUrl"
                                  :on-preview="handlePreview"
                                  :on-exceed="handleExceed"
                                  :file-list="fileList"
                                  :headers="upHeader"
                                  v-bind:on-progress="uploadVideoProcess"
                                  v-bind:on-success="handleVideoSuccess"
                                  v-bind:before-upload="beforeUploadVideo"
                                  >
                                  <el-button size="small" type="primary">点击上传</el-button>
                                  <div slot="tip" class="el-upload__tip">只能上传xlsx文件</div>
                                  <!-- <el-progress v-if="videoFlag == true"
                                               type="circle"
                                               v-bind:percentage="videoUploadPercent"
                                               style="margin-top:7px;"></el-progress> -->
                                </el-upload>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <!-- <div class="tanBtn" @click="tanyesUp()">取消</div> -->
                </div>
            </div>
            <div class="alertBox" v-if="alertShowLook" style="padding-top:6%;">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">查看</div>
                        <div class="fl_right tandel" @click="tanyesLo"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">操作人：</div>
                            <div class="fl_left file-list" style="width: 465px;"></div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">操作时间：</div>
                            <div class="fl_left file-list" style="width: 465px;"></div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">操作内容：</div>
                            <div class="fl_left file-list" style="width: 465px;"></div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <!-- <div class="tanBtn" @click="tanyesLo()">关闭</div> -->
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                alertShowLook:false,
                fileList:[],
                unpUrl:strUrl + 'loadcert',
                upHeader:{},
                videoFlag: false,
                //是否显示进度条
                videoUploadPercent: "",
                //进度条的进度，
                isShowUploadVideo: false,
                //显示上传按钮
                videoForm: {
                    showVideoPath: ''
                },
                exfile:'',
                alertShowUp:false,
                name:'',
                cardCode:'',
                xueli:'',
                cardNum:'',
                keyword:'',
                level_id:'',
                levelArr:[],
                levalId:'',
                levelList:[],
                dance:'',
                danceList:[],
                dance_id:'',
                phone:'',
                teatsex:'女',
                cert_id:'',
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                stop_reason:'',
                columns7: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '姓名',
                        align: 'center',
                        key: 'name',
                    },
                    {
                        title: '性别',
                        align: 'center',
                        key: 'sex',
                    },
                    {
                        title: '学历',
                        align: 'center',
                        key: 'education',
                    },
                    {
                        title: '证件号',
                        align: 'center',
                        key: 'card_code',
                    },
                    {
                        title: '最高级别',
                        align: 'center',
                        key: 'level_name',
                    },
                    {
                        title: '证书编号',
                        align: 'center',
                        key: 'cert_code',
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    /*h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginRight:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.cert_id=params.row.id;
                                                _this.alertShowLook=true;
                                            }
                                        }
                                    }, '查看'),*/
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginRight:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.cert_id=params.row.id;
                                                _this.getLvel(1);
                                                _this.name=params.row.name;
                                                _this.cardCode=params.row.card_code;
                                                _this.xueli=params.row.education;
                                                _this.cardNum=params.row.cert_code;
                                                _this.level_id=params.row.level_id;
                                                _this.teatsex=params.row.sex;
                                                _this.valm=1;
                                                _this.alertShow=true;
                                            }
                                        }
                                    }, '编辑'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要删除这个证书？</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deletecert',{cert_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('删除成功');
                                                                _this.search(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '删除'),
                                ]);
                            // }
                        }
                    }
                ],
                data6: [],
                alertShow:false,
                valm:0,
            }
        },
        mounted(){
            this.upHeader={
                "Authorization":localStorage.getItem('Authorization')
            }
        },
        methods:{
            daoru(){
                this.fileList=[];
                this.alertShowUp=true;
            },
            tandelUp(){
                this.alertShowUp=false;
            },
            tanyesUp(){
                this.alertShowUp=false;
            },
            tanyesLo(){
                this.alertShowLook=false;
            },
            /*handleRemove(file, fileList) {
                console.log(file, fileList);
            },*/
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                // return this.$confirm(`确定移除 ${ file.name }？`);
            },
            //上传前回调
            beforeUploadVideo(file) {
                // var fileSize = file.size / 1024 / 1024 < 50;
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                if (extension !== 'xlsx') {
                    this.$Message.error("请上传xlsx格式");
                    return false;
                }
                // if (!fileSize) {
                //     this.$Message.error("视频大小不能超过50MB");
                //     return false;
                // }
                this.isShowUploadVideo = false;
            },
            //进度条
            uploadVideoProcess(event, file, fileList) {
                this.videoFlag = true;
                this.videoUploadPercent = file.percentage.toFixed(0) * 1;
            },
            //上传成功回调
            handleVideoSuccess(res, file) {
                this.isShowUploadVideo = true;
                this.videoFlag = false;
                this.videoUploadPercent = 0;
                if (res.code == 200) {
                    // this.exfile = res.data.file;
                    this.alertShowUp=false;
                    this.search(0)
                    this.$Message.success('上传成功，解析需要1-2分钟的时间来完成，稍后刷新页面即可！');
                }
                else {
                    this.$Message.error(res.message);
                }
                //前台上传地址
                //if (file.status == 'success' ) {
                //    this.videoForm.showVideoPath = file.url;
                //} else {
                //     this.$Message.error("上传失败，请重新上传");
                //}

                //后台上传地址
                /*if (res.Code == 0) {
                    this.videoForm.showVideoPath = res.Data;
                } else {
                    this.$Message.error(res.Message);
                }*/
            },
            tanyes(index){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(_this.name==''){
                    this.$Message.error('请输入证书姓名');
                }
                else if(_this.xueli==''){
                    this.$Message.error('请输入学历');
                }
                else if(_this.cardCode==''){
                    this.$Message.error('请输入证件号');
                }
                else if(_this.level_id==''){
                    this.$Message.error('请选择级别');
                }
                else if(_this.cardNum==''){
                    this.$Message.error('请输入证书编号');
                }
                else{
                    if(index==0){
                        _this.$axios.post('addcert',{
                            name:_this.name,
                            card_code:_this.cardCode,
                            education:_this.xueli,
                            cert_code:_this.cardNum,
                            level_id:_this.level_id,
                            sex:_this.teatsex,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(1);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                    if(index==1){
                        _this.$axios.post('editcert',{
                            cert_id:_this.cert_id,
                            name:_this.name,
                            card_code:_this.cardCode,
                            education:_this.xueli,
                            cert_code:_this.cardNum,
                            level_id:_this.level_id,
                            sex:_this.teatsex,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                }
            },
            tandel(){
                this.alertShow=false;
            },
            search(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                _this.$axios.post('getcertlist',{
                    keyword:_this.keyword,
                    page:_this.pageNum,
                    level_id:_this.levalId,
                }).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.pageNum = num;
                this.search(0);
            },
            addRecruit(){
                let _this=this;
                _this.valm=0;
                _this.getLvel(0);
                _this.name='';
                _this.cardCode='';
                _this.xueli='';
                _this.cardNum='';
                _this.alertShow=true;
            },
            upload(){
                let _this=this;
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确定要下载模板?</p>',
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        // _this.$axios.post('getuploadclassuserurl',{class_id:params.row.id}).then(res=>{
                        //     if(res.data.code==200){
                                window.open('https://gewu-oss.oss-cn-zhangjiakou.aliyuncs.com/excel/%E6%A8%A1%E6%9D%BF.xlsx');
                             // }
                             // else{
                             //     this.$Message.error(res.data.message);
                             // }
                        /*}).catch(function (error) {
                          console.log(error);
                        });*/
                    },
                    onCancel: () => {
                        // this.$Message.info('取消');
                    }
                });
            },
            getLvel(index){
                let _this=this; 
                _this.$axios.post('getcertlevellist',{}).then(res=>{
                    if(res.data.code==200){
                        if(index==1){
                            _this.levelArr=res.data.data;
                        }
                        else{
                            _this.level_id=res.data.data[0].id;
                            _this.levelArr=res.data.data;
                        }
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getLvels(){
                let _this=this; 
                _this.$axios.post('getcertlevellist',{type:1}).then(res=>{
                    if(res.data.code==200){
                        _this.levelList=res.data.data;
                        _this.levalId=res.data.data[0].id;
                        _this.search(1);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
        },
        created(){
            let _this=this; 
            _this.getLvels();
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/user_mager/zs.vue